import { useCallback, useEffect, useState } from "react";
/**
 * React will automatically re-render components and forcing
 * a component re-render is not a best practice. Therefore,
 * before considering forcing a rerender, we should analyze
 * our code.
 * -------
 * Example use case:
 * In the floating toolbar component, we need to update the
 * toolbar position when the window size is changed. Without
 * forcing re-render, we need to destroy/create a new window
 * object event listener whenever the toolbar position is
 * changed. To avoid this, we will simply execute forcing
 * re-render to update the toolbar position.
 */
export var useForceRerender = function (onRerender) {
    var _a = useState({}), state = _a[0], updateState = _a[1];
    useEffect(onRerender, [state]);
    return useCallback(function () {
        updateState({});
    }, []);
};
